<template>
  <div class="container">
    <wrap-container>
      <section-label
        class="section-label"
        :value="label"
        :label-color="labelColor"
      />
      <ul :class="{ numeric: numeric, 'no-margin': noMargin }">
        <li
          v-for="(val, key) in items()"
          v-bind:key="key"
          :style="{ color: itemColor }"
          v-bind:class="liClass()"
        >
          <span
            class="label"
            :class="{ 'label-light': val.labelLight }"
            v-if="val.label"
            v-safe-html="val.label"
          />
          <p
            class="description"
            v-if="val.description"
            v-safe-html="val.description"
          />
          <span v-if="val.cbu">
            <br />
            <p class="CBU-font">
              CBU: <span id="pwd_spn" data-obfuscate>{{ val.cbu }}</span>
            </p>
            <span class="CBU-copy" @click="copyUsb">Copiar</span>
          </span>
          <span class="detail" v-if="val.detail">
            <img
              src="@/assets/img/1x/info.svg"
              width="16"
              height="16"
              alt="Ícono información"
            />
            <span class="detail-text" v-safe-html="val.detail" />
          </span>
          <p class="detail" v-if="val.link">
            <span
              class="download-card"
              v-safe-html="val.link"
              @click="downloadFile"
            ></span>
          </p>
          <p class="link-container" v-if="val.linktitle && val.linkpath">
            <span
              class="link-title"
              v-safe-html="val.linktitle"
              @click="goToLink(val.linkpath)"
            ></span>
          </p>
          <p class="detail" v-if="val.modal">
            <img
              src="@/assets/img/1x/info.svg"
              width="16"
              height="16"
              alt="Ícono información"
            />
            <span
              class="modal"
              v-safe-html="val.modal"
              @click="showModal(val.modal)"
            ></span>
          </p>
          <p v-if="val.buttonLabel && val.buttonLink">
            <sales-button
              color="#028484"
              class="boton"
              @click="goToLink(val.buttonLink)"
              :label="val.buttonLabel"
              :validateForm="false"
            />
          </p>
        </li>
      </ul>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SalesButton from "@/components/core/SalesButton";
import SectionLabel from "@/components/core/SectionLabel";
import * as END_POINTS from "@/config/constants/end-points";
import { DO_NOTIFICATION_TOAST } from "@/config/constants/action-types";
export default {
  name: "OfferGroup",
  components: { WrapContainer, SectionLabel, SalesButton },
  props: {
    label: String,
    itemColor: {
      type: String,
      default: "#535353"
    },
    labelColor: {
      type: String,
      default: "#121212"
    },
    itemIcon: {
      type: String,
      default: "azul"
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    numeric: Boolean
  },
  methods: {
    items() {
      let filter = [];
      /* Filtro solo los Slots que me interesan */
      this.$slots.default.forEach(function(val) {
        if (val.componentOptions && val.componentOptions.propsData) {
          filter.push(val.componentOptions.propsData);
        }
      });
      return filter;
    },
    liClass() {
      return {
        verde: this.itemIcon === "verde" && !this.numeric,
        azul: this.itemIcon === "azul" && !this.numeric,
        check: this.itemIcon === "check" && !this.numeric
      };
    },
    copyUsb() {
      let copyText = document.getElementById("pwd_spn");
      let textArea = document.createElement("textarea");
      textArea.value = copyText.textContent;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      textArea.remove();
      this.$store.dispatch(DO_NOTIFICATION_TOAST, {
        type: "success",
        message: "CBU copiado correctamente!"
      });
    },
    downloadFile() {
      window.open(`${END_POINTS.PDF_CARTA}`, "_blank");
    },
    showModal(modal) {
      this.$emit("showModal", modal);
    },
    goToLink(link) {
      window.open(link, "_blank");
      this.$emit("openLink");
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  white-space: normal;
  padding-left: 24px;
  margin-bottom: 40px;
}

ul li.verde:before {
  height: 12px;
  width: 12px;
  background-image: url("../../assets/img/1x/icon_ok.png");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul li.azul:before {
  height: 12px;
  width: 12px;
  background-image: url("../../assets/img/1x/list_icon.svg");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul li.check:before {
  height: 12px;
  width: 12px;
  background-image: url("../../assets/img/1x/checkmark.svg");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul.numeric {
  list-style-type: decimal;
}

ul li:before {
  content: "";
  display: inline-block;
  background-size: 12px;
  background-repeat: no-repeat;
}

li {
  font-size: 14px;
  line-height: 1.57;
  margin-bottom: 24px;
}

ul.no-margin li {
  margin-bottom: 10px;
}

.section-label {
  margin-bottom: 20px;
}

span.label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}

span.label-light {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

p.description {
  margin: 0;
}

/* Elementos con detail */
span.detail {
  display: table;
  margin-top: 20px;
}

span.detail * {
  display: table-cell;
}

span.detail img {
  margin-right: 14px;
}

.download-card {
  padding: 0 0 0 26px;
  margin-right: 32px;
  font-size: 15px;
  color: #5bbeff;
  background: url("../../assets/img/1x/download.svg") 0 1px no-repeat;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.modal {
  padding: 0 0 0 26px;
  margin-left: -13px;
  margin-right: 32px;
  font-size: 15px;
  color: #5bbeff;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.CBU-copy {
  padding: 0 0 0 18px;
  margin-right: 32px;
  margin-left: 16px;
  font-size: 15px;
  color: #5bbeff;
  background: url("../../assets/img/1x/copy.svg") 0 2px no-repeat;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.CBU-font {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.73;
  letter-spacing: normal;
  color: #ffffff;
  display: inline-block;
}

.link-container {
  margin-top: 0px;
}

.link-title {
  font-size: 15px;
  color: #1973b8;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  cursor: pointer;
}
</style>
